export const LOCAL_STORAGE_DEFAULTS = {
  PREFIX: 'app:noova-energy',
  CHUNK_SIZE: 100000, // 100KB chunks to avoid browser limits
  ENABLE_COMPRESSION: true,
  EOF_MARKER: ';',
} as const;

export interface LocalStorageConfig {
  prefix: string;
  chunkSize: number;
  enableCompression: boolean;
}